import './Collection.scss';

const Collection = () => {
  return <div>Collection</div>;
};

export default Collection;
